import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all billOfServiceses
export const getBillOfServices = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/bill-of-services`);
    return response.data;
  } catch (error) {
    console.error("Error fetching bill-of-services:", error.response?.data || error);
    throw error;
  }
};

// GET a single billOfServices
export const getBillOfServicesById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/bill-of-services/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching bill-of-services:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new billOfServices
export const createBillOfServices = async (billOfServicesData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/bill-of-services`, billOfServicesData);
    return response.data;
  } catch (error) {
    console.error("Error creating bill-of-services:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing billOfServices
export const updateBillOfServices = async (id, billOfServicesData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/bill-of-services/${id}`, billOfServicesData);
    return response.data;
  } catch (error) {
    console.error("Error updating bill-of-services:", error.response?.data || error);
    throw error;
  }
};

// DELETE a billOfServices
export const deleteBillOfServices = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/bill-of-services/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting bill-of-services:", error.response?.data || error);
    throw error;
  }
};

// GET billOfServices by taskId
export const getBillOfServicesByTaskId = async (taskId) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/bill-of-services`, {      params: { taskId },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching bill-of-services:', error.response?.data || error);
    throw error;
  }
};
